import * as React from "react";
import { EntityLabel } from './EntityLabelCorrectionWizard';

export interface EntityLabelDisplayProps {
    entityLabel: EntityLabel;
}

export const EntityLabelDisplay = ({ entityLabel }: EntityLabelDisplayProps) => {
    return (
        <span>{entityLabel.label}</span>
    );
}
